import React, { createContext, useContext, useState } from 'react';

const translations = {
  kn: {
    home: 'ಮುಖಪುಟ',
    archive: 'ಸಂಚಿಕೆಗಳು', // Professional term for editions
    aboutUs: 'ನಮ್ಮ ಬಗ್ಗೆ',
    todaysPaper: 'ಇಂದಿನ ಪತ್ರಿಕೆ',
    viewPaper: 'ಪತ್ರಿಕೆ ಓದಿ',
    readNow: 'ಈಗ ಓದಿ',
    browseArchive: 'ಹಳೆಯ ಸಂಚಿಕೆಗಳು', // More appropriate than 'ದಾಖಲೆ ವೀಕ್ಷಿಸಿ'
    searchByDate: 'ದಿನಾಂಕದ ಮೂಲಕ ಹುಡುಕಿ',
    views: 'ವೀಕ್ಷಣೆಗಳು',
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    noEditions: 'ಯಾವುದೇ ಸಂಚಿಕೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
    zoomIn: 'ಜೂಮ್ ಇನ್',
    zoomOut: 'ಜೂಮ್ ಔಟ್',
    reset: 'ಮರುಹೊಂದಿಸಿ',
    adminLogin: 'ನಿರ್ವಾಹಕ ಲಾಗಿನ್',
    username: 'ಬಳಕೆದಾರ ಹೆಸರು',
    password: 'ಪಾಸ್‌ವರ್ಡ್',
    login: 'ಲಾಗಿನ್',
    uploadNewspaper: 'ಹೊಸ ಪತ್ರಿಕೆ ಅಪ್‌ಲೋಡ್',
    manageAds: 'ಜಾಹೀರಾತುಗಳನ್ನು ನಿರ್ವಹಿಸಿ',
    date: 'ದಿನಾಂಕ',
    title: 'ಶೀರ್ಷಿಕೆ',
    selectPDF: 'PDF ಆಯ್ಕೆಮಾಡಿ',
    upload: 'ಅಪ್‌ಲೋಡ್',
    adType: 'ಜಾಹೀರಾತು ಪ್ರಕಾರ',
    adLink: 'ಜಾಹೀರಾತು ಲಿಂಕ್',
    selectImage: 'ಚಿತ್ರ ಆಯ್ಕೆಮಾಡಿ',
    logout: 'ಲಾಗೌಟ್',
    publishedOn: 'ಪ್ರಕಟಣೆಯ ದಿನಾಂಕ',
    allEditions: 'ಹಿಂದಿನ ಸಂಚಿಕೆಗಳು', // Professional archive title
    advertisement: 'ಜಾಹೀರಾತು',
    rniNumber: 'RNI ಸಂಖ್ಯೆ',
    search: 'ಹುಡುಕಿ'
  },
  en: {
    home: 'Home',
    archive: 'Editions', // Changed from Archive
    aboutUs: 'About Us',
    todaysPaper: "Today's Paper",
    viewPaper: 'View Paper',
    readNow: 'Read Now',
    browseArchive: 'Past Editions', // Changed from Browse Archive
    searchByDate: 'Search by Date',
    views: 'Views',
    loading: 'Loading...',
    noEditions: 'No editions found',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    reset: 'Reset',
    adminLogin: 'Admin Login',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    uploadNewspaper: 'Upload Newspaper',
    manageAds: 'Manage Ads',
    date: 'Date',
    title: 'Title',
    selectPDF: 'Select PDF',
    upload: 'Upload',
    adType: 'Ad Type',
    adLink: 'Ad Link',
    selectImage: 'Select Image',
    logout: 'Logout',
    publishedOn: 'Published on',
    allEditions: 'News Archive', // More specific for newspapers
    advertisement: 'Advertisement',
    rniNumber: 'RNI Number',
    search: 'Search'
  }
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('kn');

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'kn' ? 'en' : 'kn');
  };

  return (
    <LanguageContext.Provider value={{ language, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
